// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__20yXz","box":"WorkspacesBox_box__2J68j","node":"WorkspacesBox_node__1b0er"};